import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { passengersShape, legShape } from 'constants/propTypes';
import { isABSOrADSSearch } from 'utils/booking';
import { getPaxDetails } from '../JourneyDigest.utils';
import { StyledJourneySegmentContainer } from '../JourneyDigest.styles';

import JourneyDetails from '../JourneyDetails';
import JourneyDetailsWithABSADS from '../JourneyDetailsWithABSADS';

const JourneySegmentContainer = ({
  journey,
  passengers,
  direction,
  currency,
  originUIC,
  destinationUIC,
  isBookingMice = false,
  infantCount,
  isLoyaltyBooking = false
}) => {
  const paxDetails = journey && getPaxDetails(passengers, journey.legs.products);

  const isABSOrADS = isABSOrADSSearch(originUIC, destinationUIC);

  return (
    <StyledJourneySegmentContainer className={`journey-segment ${direction}`} empty={!journey} data-cy={`journey-segment-${direction}`}>
      {journey ? (
        <>
          {isABSOrADS ? (
            <JourneyDetailsWithABSADS
              journey={journey}
              passengers={passengers}
              paxDetails={paxDetails}
              direction={direction}
              currency={currency}
              originUIC={originUIC}
              destinationUIC={destinationUIC}
              isBookingMice={isBookingMice}
              infantCount={infantCount}
              isLoyaltyBooking={isLoyaltyBooking}
            />
          ) : (
            <JourneyDetails
              journey={journey}
              paxDetails={paxDetails}
              direction={direction}
              currency={currency}
              isBookingMice={isBookingMice}
              infantCount={infantCount}
              isLoyaltyBooking={isLoyaltyBooking}
            />
          )}
        </>
      ) : (
        <FormattedMessage id="journeySummary.noTrainSelected" />
      )}
    </StyledJourneySegmentContainer>
  );
};

JourneySegmentContainer.propTypes = {
  journey: legShape,
  passengers: passengersShape.isRequired,
  direction: PropTypes.string,
  currency: PropTypes.string,
  originUIC: PropTypes.string,
  destinationUIC: PropTypes.string,
  isBookingMice: PropTypes.bool,
  infantCount: PropTypes.number,
  isLoyaltyBooking: PropTypes.bool
};

export default JourneySegmentContainer;
